import React, { useState, useEffect } from 'react';
import './App.css';
import Sidebar from './components/Sidebar.js';
import Home from './components/Home';
import About from './components/About';
import Skills from './components/Skills';
import Resume from './components/Resume';
import Education from './components/Education';
import Projects from './components/Projects';
import Certifications from './components/Certifications';
import Contact from './components/Contact';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

function App() {

  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const shouldShowScrollToTop = scrollTop > 100;
    setShowScrollToTop(shouldShowScrollToTop);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleHover = (sectionId) => {
    console.log("hover kiya");
    setActiveSection(sectionId);
  };

  return (
    <>
      <div className='flex flex-row'>
        <Sidebar activeSection={activeSection} />
        <div className='absolute w-full'>
          <Home onHover={handleHover} />
          <About onHover={handleHover} />
          <Skills onHover={handleHover} />
          <Resume onHover={handleHover} />
          <Education onHover={handleHover} />
          <Projects onHover={handleHover} />
          <Certifications onHover={handleHover} />
          <Contact onHover={handleHover} />
        </div>
      </div>
      {/* <KeyboardArrowUpIcon className='fixed bottom-4 right-4 text-white bg-[#149ddd] rounded-full p-2 cursor-pointer hover:brightness-110' style={{fontSize: '2.5rem'}} onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}/> */}
      {showScrollToTop && (
        <KeyboardArrowUpIcon
          className='fixed bottom-4 right-4 text-white bg-[#149ddd] rounded-full p-2 cursor-pointer hover:brightness-110'
          style={{ fontSize: '2.5rem' }}
          onClick={scrollToTop}
        />
      )}
    </>
  );
}

export default App;
